module.exports = {
  InsureNo: 'Insure No',
  PolicyNo: 'Policy No',
  TheInsured: 'The Insured',
  DateOfShipment: 'Date Of Shipment',
  PlaceOfOrigin: 'Place Of Origin',
  Destination: 'Destination',
  BillOfLoadingNo: 'Bill Of Loading No',
  Premium: 'Premium',
  SubmissionTime: 'Submission Time',
  DeliveryTime: 'Delivery Time',
  DeliveryStatus: 'Delivery Status',
  Operation: ' 操作内容',
  EditPolicy: 'Edit Policy',
  DeletePolicy: 'Delete Policy',
  DownloadPolicy: 'Download Policy',
  CancellationOfPolicy: 'Cancellation Of Policy',
  ReIssuePolicy: 'Re Issue Policy',
  InvoiceNo: 'インボイス番号',
  PlaceOfOriginForSea: 'Port of origin',
  PlaceOfOriginForAir: 'Airport origin',
  SeaportDestination: 'Seaport Destination',
  AirportDestination: 'Airport Destination',
  N1CompleteInsuranceInformation: '1 Complete insurance information',
  N3PreviewAndConfirm: '3 Preview and confirm',
  Insured: 'Insured',
  EmailRecipient: 'Email recipient',
  GoodsCategory: 'Goods category',
  GoodsName: 'Goods name',
  MarksAndNumbers: 'Marks and Numbers',
  BillOfLadingNumber: 'Bill of lading number',
  BillOfLadingDate: 'Bill of lading date',
  InvoiceNumber: 'Invoice number',
  ContractNumber: 'Contract number',
  VesselVoyagevehiclePlateNumberflightNumber: 'Vessel voyage/vehicle plate number/flight number',
  TransportationType: 'Transportation type',
  Domestic: 'Domestic',
  Import: 'Import',
  Export: 'Export',
  TransportationMode: 'Transportation Mode',
  InlandTransportationTools: 'Inland transportation tools',
  PlaceOfDepartureport: 'Place of departure (port)',
  DepartureDate: 'Departure date',
  TransitPlaceport: 'Transit place (port)',
  Destinationport: 'Destination (port)',
  InlandStartingPoint: 'Inland starting point',
  TradeTerms: 'Trade terms',
  InvoiceAmount: 'Invoice amount',
  MainInsurance: 'Main insurance',
  LetterOfCreditConditionNumber: 'Letter of credit condition number',
  ClaimsAgentPoint: 'Claims agent point',
  Insured2: 'Insured:',
  PolicyHolder: 'Policy holder:',
  EndDateOfInsurance: 'End date of insurance:',
  DateOfInsurance: 'Date of insurance:',
  DateOfEntry: 'Date of entry:',
  MainClause: 'Main clause:',
  GoodsName2: 'Goods name:',
  InsurancePremium: 'Insurance premium:',
  InsuranceAmounttotalLimit: 'Insurance amount/total limit:',
  FinalRate: 'Final rate%:',
  AddProportion: 'Add proportion%:',
  InsuranceApplicationNumber: 'Insurance application number:',
  PolicyStatus: 'Policy status:',
  InsuranceStartDate: 'Insurance start date:',
  ReviewDate: 'Review date:',
  UnderwritingDate: 'Underwriting date:',
  CompleteInsuranceInformation: 'Complete insurance information',
  Inquire: 'Inquire',
  PreviewAndConfirm: 'Preview and confirm',
  InsuranceCompleted: 'Insurance completed',
  CancellationReason: 'Cancellation reason',
  PolicyHolderInformation: 'Policy holder information',
  SameAsPolicyHolder: 'Same as policy holder',
  GoodsInformation: 'Goods information',
  TransportationInformation: 'Transportation information',
  InsuranceAmountInformation: 'Insurance amount information',
  InsuranceConditions: 'Insurance conditions',
  FreightInsurance: 'Freight insurance',
  WPA: 'WPA',
  FPA: 'FPA',
  AllRiskForRefrigeratedGoods: 'All-risk for refrigerated goods',
  RefrigeratedInsurance: 'Refrigerated insurance',
  OtherInformation: 'Other information',
  InsuranceInstructions: 'Insurance instructions',
  TheInstitutionsWithTechnicalLtd: 'The insurance products listed on this platform are provided and sold by insurance institutions, with technical services provided by Tokio Marine & Nichido Fire Insurance (China) Co., Ltd.',
  PremiumAmount: 'Premium Amount',
  ShanghaiStorageAndTransportationLtd: 'Shanghai Jingmao Shanjiu Storage and Transportation Co., Ltd.',
  SuccessfullyInsured: 'Successfully insured!',
  PolicyNumber: 'Policy number:',
  TemporarySave: 'Temporary Save',
  PreviewAndContinue: 'Preview and Continue',
  Back: 'Back',
  PurchaseInsurance: 'Purchase Insurance',
  Submitted: 'Submitted',
  SavedSuccessfully: 'Saved Successfully',
  PleaseNameOfTheCompany: 'Please fill in the name of the cargo owner\'s company!',
  PleaseEmailSeparateMultipleSemicolons: 'Please fill in the recipients of the email! Separate multiple email recipients with English semicolons!',
  PleaseGeneralCategoryOfGoods: 'Please fill in the general category of the goods!',
  PleaseTheNameOfGoods: 'Please fill in the name of the goods!',
  PleaseInTheInvoiceNumber: 'Please fill in the invoice number',
  TheShippingMarkCannotCharacters: 'The length of the shipping mark cannot exceed 3000 characters!',
  TheCannotExceed40Characters: 'The invoice number cannot exceed 40 characters!',
  BillNumberCannotExceedCharacters: 'Bill of lading number cannot exceed 100 characters!',
  ContractCannotExceed100Characters: 'Contract number cannot exceed 100 characters!',
  PleaseVoyageNumberLicenseNumber: 'Please enter the ship name and voyage number/ license plate number/ flight number',
  PleaseEnterTheTransportationType: 'Please enter the transportation type',
  PleaseEnterTheTransportationMode: 'Please enter the transportation mode',
  PleasePlaceOfDepartureport: 'Please enter the place of departure (port)',
  PleaseEnterTheDestinationport: 'Please enter the destination (port)',
  PleaseEnterTheDepartureDate: 'Please enter the departure date',
  PleaseEnterTheTradeTerms: 'Please enter the trade terms!',
  PleaseEnterTheInvoiceAmount: 'Please enter the invoice amount!',
  PleaseEnterTheInvoiceCurrency: 'Please enter the invoice currency',
  PleaseTheClaimAgencyPoint: 'Please enter the claim agency point',
  PleaseAgreeToTheNotice: 'Please read and agree to the "Customer Notice"!',
  PolicyManagement: 'Policy Management',
  QuickSearchPolicyNumber: 'Quick Search: Policy Number',
  Cancellation: 'Cancellation',
  TotalPremium: 'Total Premium:',
  PleaseInTheCancellationReason: 'Please fill in the cancellation reason',
  YouPermissionToEditPolicy: 'You do not have permission to edit the policy',
  YouPermissionToDeletePolicy: 'You do not have permission to delete the policy',
  DeletingThePolicyRecordContinue: 'Deleting will clear the policy record, continue?',
  Confirm: 'Confirm',
  InsurancePolicyNumber: 'Insurance Policy Number',
  Deleted: 'Deleted',
  YouPermissionToCancelPolicy: 'You do not have permission to cancel the policy',
  PolicyNumber2: 'Policy Number',
  Canceled: 'Canceled',
  YouPermissionToReissuePolicy: 'You do not have permission to reissue the policy',
  YouBeforeAndCannotAgain: 'You have reissued it before and cannot reissue it again!',
  InsuranceInstructionsTip: 'I have carefully read and agreed to the "Customer Notification", "Insurance Declaration", "Platform Use Agreement", "Insurance Terms" and other contents, and understand and accept the agreements including liability clauses, exemption from liability insurance clauses, insured goods category restrictions, insured value restrictions, etc.',
  InsuranceAgent: 'Insurance Agent',
  InsuranceCompany: 'Insurance Company',
  InvoiceCurrency: 'Invoice Currency',
  InsuranceAmount: 'Insurance Amount',
  InsuranceCurrency: 'Insurance Currency',
  PremiumCurrency: 'Premium Currency',
  Rate: 'Rate',
  Waybillno: 'MBL',
  InsureOrderUser: 'Insurance Operator',
  PolicyUser: 'Policy Operator',
  ReconciliationUser: 'Reconciliation Operator',
  PolicySyncStatus: 'Policy Sync Status',
  PremiumSyncStatus: 'Premium Sync Status',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  FreightInsuranceFirstPage: 'Freight Insurance Homepage',
  LiabilityInsuranceHomepage: 'Liability Insurance Homepage',
  LiabilityInsurance: 'Liability Insurance',
  BillingManagement: 'Billing Management',
  Scanning: 'Scanning',
  Specification: 'Specification',
  ServiceAdvantages: 'Service Advantages',
  InsuranceType: 'Insurance Type',
  BillQuery: 'Bill Query',
  InvoiceDownload: 'Invoice Download',
  ViewPolicy: 'View Policy',
  PolicyDownload: 'Policy Download',
  AddInquiryQuestionnaire: 'Add Inquiry Questionnaire',
  EditOrViewQuestionnaire: 'Edit/View Questionnaire',
  QuestionnaireStatus: 'Questionnaire Status',
  PolicyStatus2: 'Policy Status',
  LiabilityInsuranceInquiry: 'Freight Forwarder Liability Insurance Inquiry',
  InquiryForQuestionnaireContent: '*The content of this questionnaire is only applicable to the inquiry of liability insurance, and Woxing and third-party companies will strictly keep it confidential;',
  AfterFillingQuestionnaire: '*After filling out this questionnaire, the third party is expected to contact and retain the phone number within 24 hours;',
  ServiceProviderSelection: 'Service Provider Selection:',
  ApplicantInformation: 'Applicant Information:',
  RegisteredAndBusiness: 'Registered name and business name of the company (if any):',
  InquiryQuestionnaire: 'Inquiry Questionnaire',
  ServiceProviderReply: 'Service Provider Reply',
  ServiceProviderReply2: 'Service Provider Reply',
  RegisteredName: 'Registered Name',
  RegisteredAddress: 'Registered Address',
  BusinessName: 'Business Name',
  BusinessAddress: 'Business Address',
  RecoveryTime: 'Recovery Time:',
  ReplyContent: 'Reply Content:',
  ExistInsuranceReocordContinue: 'The current bill of lading already has an insurance record. Do you want to continue ',
  TheInsuranceHasExist: '既に保険に加入済みであり、重複加入することはできません',
  CreatedNewInsureForm: 'creating a new insurance form',
  ToViewOriginalApplication: 'To view the original application form, please go to the ',
  Insurance: 'Insurance',
  Tab: 'tab',
  EditViewInsuranceForm: 'Edit/View Insurance Form',
  Deductible: 'Deductible',
  InsuranceCoverage: 'Insurance Coverage',
  SpecialInstructions: 'Special Instructions',
  ClaimsService: 'Claims Service',
  ServiceProviderIntroduction: 'Service Provider Introduction',
  SpecialCargo: 'Special Cargo',
  CargoExclusion: 'Cargo Exclusion',
  SpecialAgreement: 'Special Agreement',
  ChooseServiceProvider: 'Choose Service Provider',
  ViewInsurancePolicy: 'View Insurance Policy',
  RememberOperationDirectly: 'Remember this operation and directly insure next time',
  ProductValue: 'Product Value',
  Charges: 'Charges',
  MaximumIndemnityNorm: 'Maximum Indemnity Norm',
  SupplierResponse: 'Supplier Response',
  UploadedFileUnRemove: 'Uploaded files cannot be removed!',
  NoCorrespondingTemplate: 'No Corresponding Template Found!',
  NotAllowDeleteSubmited: 'The insurance record for [submitted, issued] cannot be deleted. Please reselect!',
  OnlyFileDocAndPdf: 'Only files with the suffix \'doc, docx, pdf\' can be uploaded. Please reselect!',
  ToInsure: 'Insurance:',
  FillInsuranceInformation: 'Fill In Insurance Information',
  ClickToDownloadTemplate: 'Click to download the template',
  DragFile: 'Drag files here, Or',
  ClickToUpload: 'Click to upload'
}
